import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../shared/common/Loading';
import { groupActions, participantActions } from '../../../redux/actions';
import FormGroup from './FormGroup';

const FormEditGroup = props => {
    const { group } = props;
    const { id } = useParams();

    const getInitialChecked = () =>
        group.participantes.map(g => ({
            id: g.participante_id,
        }));

    // REDUX
    const dispatch = useDispatch();
    const ondemand_id = useSelector(state => state.user.user.id);
    const loadingEditGroup = useSelector(state => state.group.loadingEditGroup);
    const participants = useSelector(state => state.participant.participants);
    const loadingParticipants = useSelector(state => state.participant.loadingParticipants);

    //EFECT
    useEffect(() => {
        if (participants === null) {
            dispatch(participantActions.getParticipantsRequest({ ondemand_id }));
        }
    }, []);

    //STATE
    const [search, setSearch] = useState('');
    const [nombre, setNombre] = useState(group?.nombre ? group?.nombre : '');
    const [checkedItems, setCheckedItems] = useState(getInitialChecked);
    const [idLeader, setIdLeader] = useState('');

    // FUNCTIONS
    function handleSearch(e) {
        setSearch(e.target.value);
    }

    function handleName(e) {
        e.preventDefault();
        setNombre(e.target.value);
    }

    function handleChecked(e) {
        if (e.target.checked) {
            setCheckedItems([...checkedItems, { id: Number(e.target.name) }]);
        } else {
            setCheckedItems(checkedItems.filter(x => x.id !== Number(e.target.name)));
        }
    }

    function handleAllChecked(e) {
        if (e.target.checked) {
            setCheckedItems(participants.map(p => ({ id: p.participante_id })));
        } else {
            setCheckedItems([]);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        dispatch(
            groupActions.editGroupRequest({
                editGroup: {
                    data_grupo: {
                        nombre,
                        group_leader_id: idLeader,
                    },
                    data_participantes: checkedItems,
                },
                ondemand_id,
                id,
            }),
        );
    }

    const setLider = leader => {
        setIdLeader(leader);
    };

    //RETURN
    if (group === null || participants === null || loadingParticipants) {
        return <Loading />;
    }
    return (
        <FormGroup
            type={'edit'}
            handleSubmit={handleSubmit}
            handleName={handleName}
            group={group}
            name={nombre}
            setLider={setLider}
            participants={participants}
            handleSearch={handleSearch}
            search={search}
            handleAllChecked={handleAllChecked}
            handleChecked={handleChecked}
            checkedItems={checkedItems}
            loadingEditGroup={loadingEditGroup}
        />
    );
};

export default FormEditGroup;
